import { render, staticRenderFns } from "./myLetter.vue?vue&type=template&id=96725516&scoped=true"
import script from "./myLetter.vue?vue&type=script&lang=js"
export * from "./myLetter.vue?vue&type=script&lang=js"
import style0 from "./myLetter.vue?vue&type=style&index=0&id=96725516&prod&lang=less&scoped=true"
import style1 from "./myLetter.vue?vue&type=style&index=1&id=96725516&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96725516",
  null
  
)

export default component.exports